import NykBasicCard from 'components/NykBasicCard/NykBasicCard.vue'
import NykButton from 'components/NykButton/NykButton.vue'
import NykInput from 'components/CustomForm/NykInput/NykInput.vue'

export default {
    name: 'DitRaaderumCalculatorInputCard',
    components: {
        NykBasicCard,
        NykButton,
        NykInput,
    },
    props: {
        labels: {
            type: Object,
            default: () => ({}),
        },
        legalLabels: {
            type: Object,
            default: () => ({}),
        },
        numberInputFormat: {
            type: Object,
            required: true,
        },
        houseValue: {
            type: String,
            default: '',
        },
        remainingDebt: {
            type: String,
            default: '',
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['update-house-value', 'update-remaining-debt', 'calculate'],
    setup(props) {
        const requiredValidators = [{
            type: 'RequiredValidator',
            model: { message: () => props.labels.requiredFieldError ?? '' },
        }]

        return { requiredValidators }
    },
}
